module.exports = __webpack_public_path__ + "static/media/mooncascade.a83ff8cd.svg";